import { render, staticRenderFns } from "./AutorisationDePratique.vue?vue&type=template&id=6bfb70f8"
import script from "./AutorisationDePratique.vue?vue&type=script&lang=js"
export * from "./AutorisationDePratique.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports